import photoPackingLine from '../../../assets/landingPage/packing-line.jpg';
import photoFacilityTourTeam from '../../../assets/landingPage/facility-tour-team.jpg';
import photoGrainQualityCheck from '../../../assets/landingPage/grain-quality-check.jpg';
import photoRawProduceDrying from '../../../assets/landingPage/raw-produce-drying.jpg';
import photoAboutHero from '../../../assets/landingPage/about-hero.jpg';
import photoAboutCta from '../../../assets/landingPage/about-cta.jpg';

// Registry of real partner/facility photography used by the custom landing-page sections
// (e.g. SectionPhotoBanner). Same rationale as landingPageIcons.js: the built-in "image"
// field type only accepts uploaded Sharetribe imageAssets, which is unnecessary friction
// for photos that belong to this hardcoded page's own design.
const landingPagePhotos = {
  packingLine: photoPackingLine,
  facilityTourTeam: photoFacilityTourTeam,
  grainQualityCheck: photoGrainQualityCheck,
  rawProduceDrying: photoRawProduceDrying,
  aboutHero: photoAboutHero,
  aboutCta: photoAboutCta,
};

export default landingPagePhotos;
